(function () {
  const video = document.getElementById('hero-video');
  if (!video) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    video.pause();
    return;
  }

  video.muted = true;
  video.defaultMuted = true;
  video.playsInline = true;
  video.setAttribute('playsinline', 'true');
  video.setAttribute('muted', 'true');
  video.setAttribute('webkit-playsinline', 'true');
  video.preload = 'auto';
  video.loop = true;

  const playVideo = async () => {
    try {
      await video.play();
    } catch {
      video.pause();
    }
  };

  const tryPlayOnInteraction = () => {
    if (!video.paused) return;
    playVideo();
  };

  if (video.readyState >= 2) {
    playVideo();
  } else {
    video.addEventListener('loadeddata', playVideo, { once: true });
    video.addEventListener('canplay', playVideo, { once: true });
  }

  document.addEventListener('pointerdown', tryPlayOnInteraction, { passive: true, once: true });
  document.addEventListener('touchstart', tryPlayOnInteraction, { passive: true, once: true });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      video.pause();
    } else {
      playVideo();
    }
  });
})();
